import gql from 'graphql-tag';
import {
  CatalogItemCardFragment,
  CatalogItemListFragment,
  CommentsItemsFragment,
  OrderItemFragment,
  ReviewsItemsFragment
} from '../fragments/fragments.cartEndpoint';

const PersonalAccQuery = {
  getOrganizationRating: gql`
    query getOrganizationRating {
      getOrganizationRating
    }
  `,
  getTestDriveProductsStats: gql`
    query getTestDriveProductsStats {
      getTestDriveProductsStats {
        catlogItems {
          id
          title
        }
        totalCount
        isValidForNewTestDrive
      }
    }
  `,
  getOrderHistoryProductStats: gql`
    query orderHistoryProductStats {
      orderHistoryProductStats(limit: 5) {
        totalOrderAmount
        stats {
          percent
          typeItem {
            id
            title
            file_url
            icon_url
          }
        }
      }
    }
  `,
  getPeopleBillAmount: gql`
    query getPeopleBillAmount {
      getPeopleBillAmount {
        people_id
        bill
        peopleItem {
          id
          can_invite
          status_id # if status_id > 1 {recommedation = true}
        }
      }
    }
  `,
  getPeopleBillLog: gql`
    query getPeopleBillLog($setLimit: Int, $page: Int) {
      getPeopleBillLog(setLimit: $setLimit, page: $page) {
        totalCount
        statusId
        totalOrdersPrice
        billLogItems {
          amount
          type
          date
          comment
        }
      }
    }
  `,
  getPeopleSettings: gql`
    query getPeopleSettings {
      getPeopleSettings {
        cabinetSettings {
          people_id
          catalog_sorting
          epp_catalog
          is_order_notify_sms
          is_order_notify_messengers
          need_digital_receipt
          pay_tip_with_bonuses
          pay_over_weight_with_bonuses
          accept_auto_payment
          save_payment_card
        }
        peopleSubscribs {
          promo
          recipes
          novelty
        }
        testDrive
      }
    }
  `,
  oneSignalSpamToogle: gql`
    mutation oneSignalSpamToogle($setSpamTo: Boolean!) {
      oneSignalSpamToogle(setSpamTo: $setSpamTo) {
        result
        info
      }
    }
  `,
  changeEmailBySms: gql`
    mutation changeEmailBySms(
      $action: PeopleSmsAction
      $email: String!
      $newEmail: String!
      $phone: String!
      $code: Int
    ) {
      changeEmailBySms(
        action: $action
        email: $email
        newEmail: $newEmail
        phone: $phone
        code: $code
      ) {
        success
        peopleExist
        info
        people {
          id
          email
          cookie_id
          cartCookieId
          status_id
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
        error
        errorCode
      }
    }
  `,
  oneSignalSpamCheck: gql`
    query oneSignalSpamCheck {
      oneSignalSpamCheck {
        result
        info
      }
    }
  `,
  savePeopleSettings: gql`
    mutation savePeopleSettings(
      $cabinetSettings: SettingsInput!
      $peopleSubscribs: SubscribesInput!
      $smsSettings: smsInput
      $bonusSettings: BonusesInput
      $cartSettings: CardInput
    ) {
      savePeopleSettings(
        cabinetSettings: $cabinetSettings
        peopleSubscribs: $peopleSubscribs
        smsSettings: $smsSettings
        bonusSettings: $bonusSettings
        cartSettings: $cartSettings
      )
    }
  `,
  // storeOrProductCommentType: StoreReview || ProductReview, productCommentType: All || Comment || Review
  getPeopleReviews: gql`
    query getPeopleReviews(
      $page: Int
      $setLimit: Int
      $type: StoreOrProductCommentsTypeEnum
      $productCommentType: ProductsCommentsTypeEnum
    ) {
      getPeopleReviews(
        page: $page
        setLimit: $setLimit
        storeOrProductCommentType: $type
        productCommentType: $productCommentType
      ) {
        totalCount
        success
        info
        warning
        error
        errorCode
        commentsItems {
          ...CommentsItemsFragment
        }
        reviewsItems {
          ...ReviewsItemsFragment
        }
      }
    }
    ${CommentsItemsFragment}
    ${ReviewsItemsFragment}
  `,

  // data: {
  //   objectId: 747732
  //   instance: Catalog
  //   commentText: "krya"
  //   rating,
  //   filesIds: [],
  //   tags: [],
  // }
  editPeopleReviewById: gql`
    mutation editPeopleReviewById(
      $data: CommentOrReviewInput!
      $toDelete: Boolean
    ) {
      editPeopleReviewById(toDelete: $toDelete, data: $data) {
        success
        info
        warning
        error
        errorCode
        commentItem {
          id
          type
          active
          item_id
          people_id
          text
          updated
        }
        reviewItem {
          id
          people_id
          fio
          text
          answer
          date
          order_id
        }
        reviewFromHostory {
          id
          people_id
          fio
          text
          answer
          date
        }
      }
    }
  `,
  getProductSubs: gql`
    query getProductSubs {
      getProductSubs {
        inStock {
          id
          type
          subedByPhone
          phone
          subedByEmail
          email
          catalogItem {
            id
            title
            mainImage
          }
        }
        priceDrop {
          id
          type
          subedByPhone
          phone
          subedByEmail
          email
          catalogItem {
            id
            title
            mainImage
          }
        }
      }
    }
  `,
  // enum CatalogSubE {
  // IN_STOCK
  // PRICE_DROP
  // }
  updateCatalogSubs: gql`
    mutation updateCatalogSubs(
      $catalogId: Int!
      $email: Boolean!
      $phone: Boolean!
      $type: CatalogSubE!
    ) {
      updateCatalogSubs(
        catalogId: $catalogId
        email: $email
        phone: $phone
        type: $type
      ) {
        id
        subedByPhone
        subedByEmail
      }
    }
  `,
  // enum CatalogSubE {
  // IN_STOCK
  // PRICE_DROP
  // }
  clearCatalogSubs: gql`
    mutation clearCatalogSubs($type: CatalogSubE!) {
      clearCatalogSubs(type: $type) {
        success
        error
      }
    }
  `,
  subscribeSMS: gql`
    mutation subscribeSMS($action: Boolean!) {
      subscribeSMS(action: $action) {
        result
        error
      }
    }
  `,

  deleteSubscriptionGR: gql`
    mutation deleteSubscribtion {
      deleteSubscribtion {
        result
        error
      }
    }
  `,
  getPeopleRecipes: gql`
    query getPeopleRecipes($page: Int, $setLimit: Int, $bludo: Int) {
      getPeopleRecipes(page: $page, setLimit: $setLimit, bludo: $bludo) {
        bludoItems {
          id
          title
        }
        totalCount
        recipesItem {
          id
          title
          isFavorite
          comments_number
          identifyIdURI
          rating
          text
          date
          recipes_difficult #  иконка с шапкой повара. от 1-го до 5
          slozhnostItem {
            id
            title
          }
          cooking_time # время приготовления
          rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
          serving # порции
          attachmentsItem {
            cacheItem {
              filePath # путь карлито
            }
          }
          bludoItem {
            id
            title
          }
        }
      }
    }
  `,
  getPeopleProducts: gql`
    query getPeopleProducts(
      $page: Int
      $setLimit: Int
      $whatProducts: String
      $searchString: String
      $identify: String
    ) {
      getPeopleProducts(
        whatProducts: $whatProducts
        setLimit: $setLimit
        page: $page
        searchString: $searchString
        identify: $identify
      ) {
        totalCount
        catalogItems {
          ...CatalogItemCardFragment
        }
        rubricMenuTree {
          id
          title
          identify
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getPeopleProfile: gql`
    query getPeopleProfile {
      getPeopleProfile {
        peopleItem {
          id
          isSubscribedToSms
          isSubscribedToEmail
          isSubscribedToPromo
          fio
          birthdayDate
          phone
          email
          cookie_id
          profile_id
          can_invite
          attachmentsItem {
            file
            tempFullFilePath
          }
          status_id
        }
        peopleProfileItems {
          id
          title
        }
      }
    }
  `,
  savePeopleProfile: gql`
    mutation savePeopleProfile($data: PeopleInput!) {
      savePeopleProfile(data: $data)
    }
  `,
  getCartTemplatesList: gql`
    query getCartTemplatesList($page: Int, $setLimit: Int) {
      getCartTemplatesList(page: $page, setLimit: $setLimit) {
        totalCount
        cabinetTemplatesItems {
          id
          title
          date
          available {
            quantity
            amount
            list {
              id
              cart_template_id
              catalog_id
              quantity
              catalogItem {
                ...CatalogItemListFragment
              }
            }
          }
          unavailable {
            quantity
            amount
            list {
              id
              cart_template_id
              catalog_id
              quantity
              catalogItem {
                ...CatalogItemListFragment
              }
            }
          }
        }
      }
    }
    ${CatalogItemListFragment}
  `,
  deleteCartTemplateItem: gql`
    query deleteCartTemplateItem($id: Int!) {
      deleteCartTemplateItem(id: $id) {
        reply {
          result
          error
        }
      }
    }
  `,
  getPeopleOrders: gql`
    query getPeopleOrders(
      $page: Int
      $setLimit: Int
      $withServices: Boolean
      $filter: getPeopleOrdersFilters!
      $includeRecipes: Boolean!
    ) {
      getPeopleOrders(
        page: $page
        setLimit: $setLimit
        withServices: $withServices
        filter: $filter
        includeRecipes: $includeRecipes
      ) {
        totalCount
        orderThatUserCanChange {
          id
        }
        ordersList {
          ...OrderItemFragment
        }
      }
    }
    ${OrderItemFragment}
  `,
  saveCartTemplateItem: gql`
    mutation saveCartTemplateItem($cartToken: String!, $title: String) {
      saveCartTemplateItem(cartToken: $cartToken, title: $title) {
        reply {
          result
          data
          error
        }
      }
    }
  `,

  getPeopleOrderById: gql`
    query getPeopleOrderById($orderId: Int!, $includeRecipes: Boolean!) {
      getPeopleOrderById(orderId: $orderId, includeRecipes: $includeRecipes) {
        orderThatUserCanChange {
          id
        }
        orderItem {
          ...OrderItemFragment
        }
      }
    }
    ${OrderItemFragment}
  `,

  getOrderAndAddressComments: gql`
    query getOrderAndAddressComments($addressId: Int, $orderId: Int) {
      getOrderAndAddressComments(addressId: $addressId, orderId: $orderId) {
        address {
          id
          type
          commentItems {
            value
            comment {
              id
              active
              attachment
              type
              title
              description
              placeholder
              required
              sort
            }
            option {
              id
              comment
              active
              title
              sort
            }
          }
        }
        order {
          id
          type
          commentItems {
            value
            comment {
              id
              active
              attachment
              type
              title
              description
              placeholder
              required
              sort
            }
            option {
              id
              comment
              active
              title
              sort
            }
          }
        }
      }
    }
  `,
  confirmOrderById: gql`
    query confirmOrderById($hash: String!, $orderId: Int!) {
      confirmOrderById(hash: $hash, orderId: $orderId) {
        id
        coords
        date
        table
        deliveryStoreItem {
          id
          shop {
            id
            tips
          }
        }
        orderContainerPrice
        canOrderBeChanged
        deliveryDate
        people_id
        delivery_title
        canOrderBeChanged
        peopleToken
        need_receipt
        delivery_id
        bill_recieve_after_delivery
        totalOrderItemsPrice
        servicesItems {
          amount
          price
          serviceItem {
            id
            title
            price
          }
        }
        addressItem {
          title
          flat
          comment
        }
        promocodeItem {
          value
          id
          title
          type_id
          order_price
          type
          code
        }
        amount
        paid
        paid_total
        status_id
        ord_weight
        email
        bill_payed
        bill_received
        discount
        ordersItems {
          getTotalOrderItemPrice
          catalog_id
          amount
          weight
          weight_total
          ord_weight
          price
          getOrderItemWeightPrice
          catalogItem {
            title
            vesovoi
            fileItem {
              cacheItem {
                filePath
              }
            }
            oldPriceField
            oldPriceField2
            discounPriceField
            discounPriceField2
            currentPriceField

            mainRootRubric {
              id
              title
              shortTitle
              short_title
              identify
            }
          }
        }
        address_id
        addressItem {
          flat
          comment
        }
        dadataItem {
          id
          geo_lat
          geo_lon
          city_type
          city
          settlement_type
          settlement
          street_type
          street
          house_type
          house
          block_type
          block
          is_fixed
          flat
        }

        ordBeg
        ordEnd
        phone
        delivery_cost
        price
        payment_id
        fio
        one_click

        fromPeopleFio
        fromPeoplePhone
        fromPeopleEmail
        digitalPromocodes
      }
    }
  `,
  getThankYouPromotionProducts: gql`
    query getThankYouPromotionProducts($date: DateTime!, $orderId: Int!) {
      getThankYouPromotionProducts(date: $date, orderId: $orderId) {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getProductsByIds: gql`
    query getProductsByIds($ids: [Float!], $imageSizeFilter: String) {
      getProductsByIds(ids: $ids, imageSizeFilter: $imageSizeFilter) {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getOrdersThatUserCanChange: gql`
    query getOrdersThatUserCanChange {
      getOrdersThatUserCanChange
    }
  `,
  getPeopleLastDeliveredOrderId: gql`
    query getPeopleLastDeliveredOrderId {
      getPeopleLastDeliveredOrderId
    }
  `,

  getPeopleRecycleStats: gql`
    query getPeopleRecycleStats($peopleId: Float, $cartToken: String!) {
      getPeopleRecycleStats(peopleId: $peopleId, cartToken: $cartToken) {
        service {
          id
          title
          svg_code

          type_id
          short_description
          short_description_with_subscription
          description
          price
          subscription_price
          price_with_subscription
          subscription_period
          max_quantity_in_order
          created_at
          modified_at
          has_related_products
          is_multiple
          is_active
          is_group
          is_service_and_subscription_same_time
          sorting_weight
          is_hidden
          hasDescription
          servicesModel
        }
        peopleId
        amount

        button
        period
        price
      }
    }
  `,
  getNewsWithPeopleCharityDonations: gql`
    query getNewsWithPeopleCharityDonations($peopleId: Float) {
      getNewsWithPeopleCharityDonations(peopleId: $peopleId) {
        entity {
          id
          title
          svg_code
          active

          attachmentsItem {
            cacheItem {
              filePath
            }
          }
        }
        peopleId
        donation
      }
    }
  `,
  setOrderPaymentType: gql`
    mutation setOrderPaymentType($paymentId: Int!, $orderId: Int!) {
      setOrderPaymentType(paymentId: $paymentId, orderId: $orderId) {
        success
        orderItem {
          id
          payment_id
          payment_title
        }
        info
        warning
        error
        errorCode
      }
    }
  `,
  rebindCartPid: gql`
    mutation rebindCartPid($cartToken: String, $peopleToken: String) {
      rebindCartPid(cartToken: $cartToken, peopleToken: $peopleToken) {
        success
        info
        warning
        error
        errorCode
      }
    }
  `,

  addTipsForCourier: gql`
    mutation addTipsForCourier($courierId: Int!, $bonuses: Int!) {
      addTipsForCourier(courierId: $courierId, bonuses: $bonuses)
    }
  `,
  GRSubAction: gql`
    mutation GRSubAction($email: String, $action: subscribtionAction) {
      GRSubAction(email: $email, action: $action) {
        result
        error
        message
      }
    }
  `,
  checkGRSub: gql`
    mutation checkGRSub {
      checkGRSub
    }
  `,
  getSBPLink: gql`
    query getSBPLink($order: Int!) {
      getSBPLink(order: $order) {
        success
        info
        warning
        error
        errorCode
        apiResponse {
          data {
            amount
            payment_id
            link
            banks {
              title
              support
              image
              ios {
                scheme
                link
              }
              android {
                package
                intent
                link
              }
            }
          }
          error
          errors {
            value
            msg
            param
            location
          }
          errorCode
        }
      }
    }
  `,
  checkSBPStatus: gql`
    query checkSBPStatuses($paymentId: Float!) {
      checkSBPStatuses(paymentId: $paymentId) {
        success
        info
        warning
        error
        errorCode
      }
    }
  `
};

export default PersonalAccQuery;
